module.exports = __webpack_public_path__ + "img/benefit1.192a2e96.png";